import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import SwitchLaborCostMode from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/labor-cost/SwitchLaborCostMode.tsx";
import SwitchLaborCostService from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/labor-cost/SwitchLaborCostService.tsx";
import LaborCostSummary from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/labor-cost/LaborCostSummary.tsx";
import { useLaborCostCardController } from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/labor-cost/useLaborCostCardController.ts";
import LaborCostChart from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/labor-cost/chart/LaborCostChart.tsx";
import "./LaborCostCard.scss";
import { CircularProgress } from "@mui/material";

export default function LaborCostCard(): ReactNode {
  const { t } = useTranslation("humanResources");

  const {
    mode,
    setMode,
    selectedServiceIndex,
    setSelectedServiceIndex,
    isFetching,
    chartData,
    isEnabled,
  } = useLaborCostCardController();

  const hasData = chartData !== undefined;

  if (!isEnabled) return undefined;
  return (
    <div className="labor-cost-card">
      <div className="card-header">
        <div className="card-title">
          {t("timeManagement.analysis.indicators.laborCost.label")}
        </div>
      </div>
      <div className="card-body">
        {isFetching && (
          <div className="loading-progress">
            <CircularProgress />
          </div>
        )}
        {!isFetching && hasData && (
          <>
            <div className="labor-cost-col left">
              <SwitchLaborCostMode mode={mode} onChange={setMode} />
              <SwitchLaborCostService
                selectedServiceIndex={selectedServiceIndex}
                onChange={setSelectedServiceIndex}
                services={chartData.services}
              />
            </div>
            <div className="labor-cost-col chart">
              <LaborCostChart data={chartData} />
            </div>
            <div className="labor-cost-col right">
              <LaborCostSummary data={chartData} />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
